// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 패스워드 변경 모달 스타일 */

.password-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;
}

.password-modal {
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 450px;
    max-height: calc(90vh / var(--app-zoom, 1));
    overflow-y: auto;
    position: relative;
    animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

.password-modal-header {
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid #e9ecef;
    position: relative;
}

.password-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0 0 12px 0;
    text-align: center;
}

.password-modal-warning {
    background-color: #fff3e0;
    border: 1px solid #ffb74d;
    color: #e65100;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    margin: 0;
    text-align: center;
    line-height: 1.4;
}

.password-modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
    line-height: 1;
    transition: color 0.2s ease;
}

.password-modal-close:hover {
    color: #495057;
}

.password-modal-form {
    padding: 24px;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
}

.form-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    background-color: #fff;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #6c757d;
    box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.1);
}

.form-input:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
    opacity: 0.7;
}

.form-input::placeholder {
    color: #adb5bd;
}

.password-hint {
    margin-top: 6px;
}

.password-hint small {
    color: #6c757d;
    font-size: 12px;
    line-height: 1.4;
}

.error-message {
    background-color: #ffeaa7;
    border: 1px solid #fdcb6e;
    color: #e17055;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.error-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.error-text {
    flex: 1 1;
    line-height: 1.4;
}

.success-message {
    background-color: #d4edda;
    border: 1px solid #81c784;
    color: #2e7d32;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.success-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.success-text {
    flex: 1 1;
    line-height: 1.4;
}

.password-modal-buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
}

.password-button {
    flex: 1 1;
    padding: 14px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.password-button.primary {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    color: white;
}

.password-button.primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #5a6268 0%, #3d4142 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.password-button.secondary {
    background-color: #f8f9fa;
    color: #495057;
    border: 2px solid #e9ecef;
}

.password-button.secondary:hover:not(:disabled) {
    background-color: #e9ecef;
    border-color: #dee2e6;
    transform: translateY(-1px);
}

.password-button.logout {
    background-color: #dc3545;
    color: white;
    border: 2px solid #dc3545;
}

.password-button.logout:hover:not(:disabled) {
    background-color: #c82333;
    border-color: #bd2130;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.password-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
}

/* 로딩 상태 애니메이션 */
.password-button.primary:disabled {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    position: relative;
}

.password-button.primary:disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    animation: loading 1.5s infinite;
}

@keyframes loading {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

/* 반응형 디자인 */
@media (max-width: 480px) {
    .password-modal-overlay {
        padding: 10px;
    }
    
    .password-modal {
        max-width: 100%;
    }
    
    .password-modal-header {
        padding: 20px 16px 12px 16px;
    }
    
    .password-modal-form {
        padding: 16px;
    }
    
    .password-modal-title {
        font-size: 18px;
    }
    
    .password-modal-buttons {
        flex-direction: column;
        gap: 10px;
    }
    
    .password-button {
        padding: 12px 16px;
    }
}

/* 강제 변경 모드 스타일 강화 */
.password-modal-overlay.force-change {
    background-color: rgba(0, 0, 0, 0.8);
}

.password-modal.force-change {
    border: 2px solid #ff9800;
    box-shadow: 0 20px 50px rgba(255, 152, 0, 0.2);
}

.password-modal.force-change .password-modal-title {
    color: #e65100;
}`, "",{"version":3,"sources":["webpack://./src/components/PasswordChangeModal.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,gCAAgC;AACpC;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,oBAAoB;AACpB;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* 패스워드 변경 모달 스타일 */\r\n\r\n.password-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.password-modal {\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\r\n    width: 100%;\r\n    max-width: 450px;\r\n    max-height: calc(90vh / var(--app-zoom, 1));\r\n    overflow-y: auto;\r\n    position: relative;\r\n    animation: modalFadeIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes modalFadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.9) translateY(-20px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1) translateY(0);\r\n    }\r\n}\r\n\r\n.password-modal-header {\r\n    padding: 24px 24px 16px 24px;\r\n    border-bottom: 1px solid #e9ecef;\r\n    position: relative;\r\n}\r\n\r\n.password-modal-title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin: 0 0 12px 0;\r\n    text-align: center;\r\n}\r\n\r\n.password-modal-warning {\r\n    background-color: #fff3e0;\r\n    border: 1px solid #ffb74d;\r\n    color: #e65100;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    margin: 0;\r\n    text-align: center;\r\n    line-height: 1.4;\r\n}\r\n\r\n.password-modal-close {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    color: #6c757d;\r\n    cursor: pointer;\r\n    padding: 4px;\r\n    line-height: 1;\r\n    transition: color 0.2s ease;\r\n}\r\n\r\n.password-modal-close:hover {\r\n    color: #495057;\r\n}\r\n\r\n.password-modal-form {\r\n    padding: 24px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-label {\r\n    display: block;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.form-input {\r\n    width: 100%;\r\n    padding: 12px 16px;\r\n    border: 2px solid #e1e5e9;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    background-color: #fff;\r\n    transition: all 0.2s ease;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.form-input:focus {\r\n    outline: none;\r\n    border-color: #6c757d;\r\n    box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.1);\r\n}\r\n\r\n.form-input:disabled {\r\n    background-color: #f8f9fa;\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n}\r\n\r\n.form-input::placeholder {\r\n    color: #adb5bd;\r\n}\r\n\r\n.password-hint {\r\n    margin-top: 6px;\r\n}\r\n\r\n.password-hint small {\r\n    color: #6c757d;\r\n    font-size: 12px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.error-message {\r\n    background-color: #ffeaa7;\r\n    border: 1px solid #fdcb6e;\r\n    color: #e17055;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    margin-bottom: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.error-icon {\r\n    font-size: 16px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.error-text {\r\n    flex: 1;\r\n    line-height: 1.4;\r\n}\r\n\r\n.success-message {\r\n    background-color: #d4edda;\r\n    border: 1px solid #81c784;\r\n    color: #2e7d32;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    margin-bottom: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.success-icon {\r\n    font-size: 16px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.success-text {\r\n    flex: 1;\r\n    line-height: 1.4;\r\n}\r\n\r\n.password-modal-buttons {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-top: 24px;\r\n}\r\n\r\n.password-button {\r\n    flex: 1;\r\n    padding: 14px 20px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    text-align: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.password-button.primary {\r\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\r\n    color: white;\r\n}\r\n\r\n.password-button.primary:hover:not(:disabled) {\r\n    background: linear-gradient(135deg, #5a6268 0%, #3d4142 100%);\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\r\n}\r\n\r\n.password-button.secondary {\r\n    background-color: #f8f9fa;\r\n    color: #495057;\r\n    border: 2px solid #e9ecef;\r\n}\r\n\r\n.password-button.secondary:hover:not(:disabled) {\r\n    background-color: #e9ecef;\r\n    border-color: #dee2e6;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.password-button.logout {\r\n    background-color: #dc3545;\r\n    color: white;\r\n    border: 2px solid #dc3545;\r\n}\r\n\r\n.password-button.logout:hover:not(:disabled) {\r\n    background-color: #c82333;\r\n    border-color: #bd2130;\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n.password-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: none !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n/* 로딩 상태 애니메이션 */\r\n.password-button.primary:disabled {\r\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\r\n    position: relative;\r\n}\r\n\r\n.password-button.primary:disabled::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n    animation: loading 1.5s infinite;\r\n}\r\n\r\n@keyframes loading {\r\n    0% {\r\n        left: -100%;\r\n    }\r\n    100% {\r\n        left: 100%;\r\n    }\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 480px) {\r\n    .password-modal-overlay {\r\n        padding: 10px;\r\n    }\r\n    \r\n    .password-modal {\r\n        max-width: 100%;\r\n    }\r\n    \r\n    .password-modal-header {\r\n        padding: 20px 16px 12px 16px;\r\n    }\r\n    \r\n    .password-modal-form {\r\n        padding: 16px;\r\n    }\r\n    \r\n    .password-modal-title {\r\n        font-size: 18px;\r\n    }\r\n    \r\n    .password-modal-buttons {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n    \r\n    .password-button {\r\n        padding: 12px 16px;\r\n    }\r\n}\r\n\r\n/* 강제 변경 모드 스타일 강화 */\r\n.password-modal-overlay.force-change {\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.password-modal.force-change {\r\n    border: 2px solid #ff9800;\r\n    box-shadow: 0 20px 50px rgba(255, 152, 0, 0.2);\r\n}\r\n\r\n.password-modal.force-change .password-modal-title {\r\n    color: #e65100;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
